export default function formatPLORangeData(rangeData) {
	let array = rangeData.split("\n");

	// array = Array.from({ length: array.length / 2 }, (_, i) => array[2 * i] + ";" + array[2 * i + 1].split(";")[0]);
	let formattedData = {};

	for (let i = 0; i < array.length - 1; i = i + 2) {
		const hand = array[i].trim();
		const freq = array[i + 1].split(";")[0].trim();
		if (freq === "0.0") continue;
		formattedData[hand] = freq;
	}

	// //To make sure that even if there is a spot where you'd never take the action there is still an object representing it in the DB
	if (Object.keys(formattedData).length === 0) formattedData["AAAA"] = "0.0";

	return formattedData;
}
